import { render, staticRenderFns } from "./ArchiveMasterProposals.vue?vue&type=template&id=0d9b0b86&scoped=true&"
import script from "./ArchiveMasterProposals.vue?vue&type=script&lang=js&"
export * from "./ArchiveMasterProposals.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveMasterProposals.vue?vue&type=style&index=0&id=0d9b0b86&prod&lang=css&"
import style1 from "./ArchiveMasterProposals.vue?vue&type=style&index=1&id=0d9b0b86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9b0b86",
  null
  
)

export default component.exports